import * as Types from '../types';
import * as constants from '../constants';
import { useTranslations } from './useTranslations';

export const useSmartTranslations = () => {
    const translate = useTranslations();

    return (
        tk: string,
        ...args: Types.TTranslationArguments
    ): string => tk.startsWith(constants.TK_PREFIX) ? translate(tk, ...args) : tk;
};
